import React, { useState } from "react";
import styled from "styled-components";
import AssetsImg from "lib/images/assets.svg";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Takeaway from "./components/Takeaway";
import LoanTerms from "./components/LoanTerms";
import DonutChart from "./components/DonutChart";

const Wrapper = styled.div`
  max-width: 612px;
  margin-left: auto;
  margin-right: auto;
`;

const Part1 = styled.div`
  padding: 24px;
  display: flex;
`;

const Half = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Schedule = styled.div`
  padding-left: 14px;
  padding-top: 16px;
  margin-top: 16px;
  margin-left: 26px;
  border-top: 1px solid #dadce0;
`;

const AssetTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AssetTitle2 = styled.div`
  font-size: 10px;
  color: #5f6368;
  display: flex;
  align-items: center;
`;

const AssetImg = styled.img`
  margin-left: 6px;
  margin-top: -6px;
  width: 18px;
`;

const AssetItem = styled.div`
  font-size: 12px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AssetLabel = styled.span`
  color: #5f6368;
`;

const AssetValue = styled.span`
  color: #000;
`;

const DetailTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin: 14px 0;
  padding: 0 24px;
`;

const Detail = styled.div`
  background: #f4f4f4;
  padding: 32px;
  border-top: 1px solid #dadce0;
  border-bottom: 1px solid #dadce0;
  display: flex;
  justify-content: space-between;
`;

const Item = styled.div`
  flex: 1;
  text-align: center;
`;

const ItemTitle = styled.div`
  font-size: 16px;
  color: #000;
`;

const ItemValue = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #7f322f;
  margin-top: 17px;
  margin-bottom: 15px;
`;

const ItemSecond = styled.div`
  font-size: 14px;
  color: #5f6368;
`;

const RefiCashout = props => {
  const assets = [
    { label: "Market Value", value: "$69,297,135" },
    { label: "Cap Rate", value: "3.76%" },
    { label: "NOI Actual", value: "$2,625,744" }
  ];

  const data = [
    {
      label: "DSCR",
      value: "$38,331,000",
      month: "$173,763",
      year: "$2,100,000"
    },
    {
      label: "LTV",
      value: "$41,331,000",
      month: "$173,763",
      year: "$2,100,000"
    },
    {
      label: "Debt Yield",
      value: "$43,331,000",
      month: "$173,763",
      year: "$2,100,000"
    }
  ];

  return (
    <Wrapper>
      <Header
        dealName="Arbors of Anderson"
        type="Refi Cashout"
      />
      <Part1>
        <Half>
          <Takeaway
            condition="If you refinance today at your assumed terms"
            type="net cash out"
            amount="$8,665,143"
            percent="29%"
          />
          <LoanTerms
            title="ASSUMED TERMS"
            items={[
              { label: "Loan Type", value: "Freddie Mac" },
              { label: "Loan Term", value: "7 years" },
              { label: "Rate Type", value: "Floating" },
              { label: "Index", value: "1M LIBOR" },
              { label: "Spread", value: "2.20%" },
              { label: "UW Rate", value: "3.00%" },
              { label: "Amort Term", value: "360" },
              { label: "Min DSCR", value: "1.25x" },
              { label: "Max LTV", value: "65.00%" },
              { label: "Min DY", value: "8.50%" }
            ]}
          />
        </Half>
        <Half>
          <DonutChart
            height={270}
            title={["Loan Proceeds", "$1,331,000"]}
            data={[
              {
                label: "Net Cash Out",
                value: 643194,
                color: "#3c4d4f"
              },
              {
                label: "Closing Costs",
                value: 100000,
                color: "#000"
              },
              {
                label: "Prepayment",
                value: 87805,
                color: "#c4c4c4"
              },
              {
                label: "Loan Balance",
                value: 500000,
                color: "#7f322f"
              }
            ]}
          />
          <Schedule>
            <AssetTitle>
              ASSET ASSUMPTIONS
              <AssetTitle2>
                2 properties
                <AssetImg src={AssetsImg} alt="assets" />
              </AssetTitle2>
            </AssetTitle>
            {assets.map(asset => (
              <AssetItem>
                <AssetLabel>{asset.label}</AssetLabel>
                <AssetValue>{asset.value}</AssetValue>
              </AssetItem>
            ))}
          </Schedule>
        </Half>
      </Part1>
      <DetailTitle>MAX PROCEEDS BY UNDERWRITING CONSTRAINT</DetailTitle>
      <Detail>
        {data.map(item => (
          <Item>
            <ItemTitle>{item.label}</ItemTitle>
            <ItemValue>{item.value}</ItemValue>
            <ItemSecond>
              {item.month}
              {" "}
              monthly
            </ItemSecond>
            <ItemSecond>
              {item.year}
              {" "}
              annually
            </ItemSecond>
          </Item>
        ))}
      </Detail>

      <Footer />
    </Wrapper>
  );
};

export default RefiCashout;
